import { render, staticRenderFns } from "./BAVideoTimelineSlider.vue?vue&type=template&id=5bba1c9a&scoped=true&"
import script from "./BAVideoTimelineSlider.vue?vue&type=script&lang=ts&"
export * from "./BAVideoTimelineSlider.vue?vue&type=script&lang=ts&"
import style0 from "./BAVideoTimelineSlider.vue?vue&type=style&index=0&id=5bba1c9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bba1c9a",
  null
  
)

export default component.exports